/**
 * @freesewing/plugin-grainline | v2.17.1
 * A FreeSewing plugin to add grainline indicators on your patterns
 * (c) 2021 Joost De Cock <joost@joost.at> (https://github.com/joostdecock)
 * @license MIT
 */
var markers = `
<marker orient="auto" refY="0.0" refX="0.0" id="grainlineFrom" style="overflow:visible;" >
	<path class="note fill-note" d="M 0,0 L 12,-4 C 10,-2 10,2  12, 4 z" />
</marker>
<marker orient="auto" refY="0.0" refX="0.0" id="grainlineTo" style="overflow:visible;" >
	<path class="note fill-note" d="M 0,0 L -12,-4 C -10,-2 -10,2  -12, 4 z" />
</marker>
`;

var name = "@freesewing/plugin-grainline";
var version = "2.17.1";

var index = {
  name: name,
  version: version,
  hooks: {
    preRender: function (svg) {
      if (svg.attributes.get('freesewing:plugin-grainline') === false) {
        svg.attributes.set('freesewing:plugin-grainline', version);
        svg.defs += markers;
      }
    },
  },
  macros: {
    grainline: function (so) {
      if (so === false) {
        delete this.points.grainlineFrom;
        delete this.points.grainlineTo;
        delete this.paths.grainline;
        return true
      }
      let points = this.points;
      points.grainlineFrom = so.from.shiftFractionTowards(so.to, 0.05);
      points.grainlineTo = so.to.shiftFractionTowards(so.from, 0.05);
      this.paths.grainline = new this.Path()
        .move(points.grainlineFrom)
        .line(points.grainlineTo)
        .attr('class', 'note')
        .attr('marker-start', 'url(#grainlineFrom)')
        .attr('marker-end', 'url(#grainlineTo)')
        .attr('data-text', 'grainline')
        .attr('data-text-class', 'center fill-note');
    },
  },
};

export default index;
//# sourceMappingURL=index.mjs.map
